import styled from 'styled-components';
import bg from 'images/sec1-bg.jpg';

export const Wrapper = styled.main`
  font-family: 'Raleway', sans-serif;
  margin-top: -130px;
  padding-top: 130px;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;
  background: rgb(164, 15, 19)url(${bg}) top/cover no-repeat;
  flex-direction: column;
  > section {
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    max-width: 1600px;
    width: 100%;
    margin: 0 auto;
    padding: 0px 0 50px;
    align-items: flex-end;

    @media (max-width: 900px) {
      flex-direction: column;
      justify-content: flex-start;
    }
    @media (max-width: 600px) {
    }
    > article {
      padding: 30px;
      flex: 0 0 50%;
      @media (max-width: 900px) {
        flex: 0 0 100%;
      }
    }
    > aside {
      padding: 30px;
      flex: 0 0 50%;
      @media (max-width: 900px) {
        flex: 0 0 100%;
      }
    }
  }

  .book-cover {
    position: absolute;
    bottom: 220px;
    left: 830px;
    width: 700px;
    @media (max-width: 1400px) {
      width: 700px;
    }
    @media (max-width: 1200px) {
      display: none;
    }
  }
  .title-header {
    // background: #D62027;
  }
  .d-grid {
    display: grid;
    grid-template-columns: 1fr 1600px 1fr;
    @media (max-width: 700px) {
      display: block;
    }
  }
  .div-block-red {
    background: #D62027;
  }
`;

export const SubmitBtn = styled.button`
  font-family: 'Raleway',sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.03em;

  background: #FFFF00;
  border-radius: 12px;
  margin-top: 20px;
  padding: 15px 20px;
  line-height: 1.4;
  color: #000;
  border: none;
  @media (max-width: 600px) {
    letter-spacing: 0.15em;
  }
  &:hover {
    opacity: 0.9;
  }
`;


export const Content = styled.div`
  width: 100%;
  h1 {
    font-size: 48px;
    font-weight: 900;
    color: #fff;
    @media (max-width: 600px) {
      font-size: 32px;
    }
    i {
      color: #000;
      font-style: normal;
    }
    span.red {
      color: #D62027;
    }
  }
  h2 {
    font-size: 30px;
    font-weight: 700;
    background: #D62027;
    color: #fff;
    display: inline-block;
    border-radius: 0px 10px 10px 0px;
    margin-bottom: 0px;
    padding: 10px 30px;
    span {
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      letter-spacing: 0.06em;
      text-transform: uppercase;
    }
    @media (max-width: 700px) {
      font-size: 23px;
    }
  }
  .logo {
    width: 160px;
    margin-bottom: 30px;
  }
  .list-content {
    font-family: 'Open Sans', sans-serif;
    margin: 30px 0;
    li {
      display: flex;
      margin-bottom: 30px;
      align-items: center;
      align-items: flex-start;
      img {
        width: 15px;
        height: 16px;
        flex: 0 0 20px;
        margin-top: 3px;
      }
      p {
        font-size: 20px;
        color: #fff;
        padding-left: 10px;
        font-weight: 600;
        @media (max-width: 600px) {
          font-size: 16px;
        }
      }
    }
  }
  .info-links {
    display: flex;
    color: #fff;
    font-size: 12px;
    margin-top: 65px;
    align-items: center;

    font-family: 'Open Sans', sans-serif;

    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.01em;

    @media (max-width: 700px) {
      margin-top: 30px;
      flex-wrap: wrap;
    }
    li {
      margin: 0 5px;
      @media (max-width: 700px) {
        font-size: 10px;
        margin: 5px;
      }
      button {
        background: transparent;
        border-radius: 7px;
        border: none;
        padding: 7px;
        font-weight: 600;
        border: 1px solid white;
        color: white;
      }
    }
  }
`;

export const Testimonial = styled.div`
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  @media (max-width: 600px) {
    flex-direction: column;
  }

  .item {
    background: rgba(16, 15, 15, 0.5);
    backdrop-filter: blur(10px);

    border-radius: 10px;
    padding: 20px;
    flex: 0 0 50%;
    margin-bottom: 10px;
    &:last-child {
    margin-bottom: 0px;
    }
    @media (max-width: 600px) {
      flex: 0 0 100%;
      margin-bottom: 40px;
    }
    img {
      width: 81px;
      height: 81px;
      margin-right: 20px;
    }
    p {
      font-size: 15px;
      font-style: italic;
      color: #fff;
      font-weight: 300;
      margin-bottom: 15px;
      line-height: 19.6px;
    }
    small {
      font-weight: 400;
      color: #fff;
      font-size: 14px;
      line-height: 18.2px;
      strong {
        font-weight: 700;
      }
    }
  }

  .author {
    display: flex;
    align-items: center;
  }
`;
